<div class="shadow" *ngIf="hasShadow$ | async"></div>
<div
  class="wrapper h-100"
  [class.bare-layout]="bareLayout"
  *ngIf="{
    authorized: isAuthenticated$ | async,
    isPresentation: isPresentationMode$ | async,
  } as data"
>
  <app-header *ngIf="data.authorized && !hideHeader"> </app-header>
  <app-progress-bar
    class="position-absolute w-100"
    *ngIf="storeService.isLoading$ | async"
  ></app-progress-bar>
  <div class="content" [ngClass]="{ logged: isAuthenticated$ | async }">
    <app-banner-container></app-banner-container>
    <div class="pane-container">
      <app-main-menu *ngIf="data.authorized && !hideHeader"></app-main-menu>

      <router-outlet></router-outlet>
    </div>
    <ng-toast></ng-toast>
  </div>
  <ng-container *ngIf="userHasBackgroundTasks$ | async">
    <app-user-background-task-list
      [userBackgroundTasks]="userBackgroundTasks$ | async"
    ></app-user-background-task-list>
  </ng-container>
  <app-release-notes *ngIf="userAccessLevel >= UserAccessLevel.GLOBAL_ADMIN">
  </app-release-notes>
</div>
